import {useEffect} from 'react';
import {useCurrentInvoice} from '../containers/invoice-context/invoice-context';
import {useUpdateInvoiceDetailsMutation} from '../store/endpoints/update-invoice-details';
import {DocumentResponse} from 'features/commercial/documents/containers/document-context/document-context';
import hydrateFields from 'features/commercial/documents/store/actions/hydrate-fields';
import selectDocumentFormBody from 'features/commercial/documents/store/selectors/select-document-form-body';
import {actions} from 'features/commercial/documents/store/slice';
import {useDispatch, useSelector} from 'react-redux';
import {parseValidationErrors} from 'services/api/utils/parse-error';
import toast from 'store/ui/actions/toast';
import {useTranslation} from 'react-i18next';

const __DEV__ = process.env.NODE_ENV === 'development';

export default (): DocumentResponse => {
  const [commit, {isLoading, error, isSuccess, reset}] =
    useUpdateInvoiceDetailsMutation();

  const serverError = parseValidationErrors(error);
  const {t} = useTranslation();

  const doc = useCurrentInvoice();

  const payload = useSelector(selectDocumentFormBody);

  const handleSubmit = async () => {
    const result = await commit({
      id: doc.id,
      ...payload,
    });
    if ('data' in result) {
      dispatch(toast('success', t('common.changesCommited')));
    }
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (doc) {
      dispatch(hydrateFields(doc));
    }
    return () => {
      dispatch(actions.reset());
    };
  }, [doc]);

  return {
    errorMessage: serverError.message,
    isLoading,
    isSuccess,
    submit: handleSubmit,
    validationErrors: serverError.errors,
    reset,
    doc_type: 'invoice',
    doc: doc,
    is_locked: doc?.status === 'VALIDATED',
  };
};
